import React, {Fragment, useRef, useContext} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import {getParamList, Globals} from "../DataFunctions/BaseDataFns";

import './TableMyPEPs.scss'
import IconTooltip from "ui/Tooltip/IconTooltip";
import PassportTable, {xlateBootstrapTableColumns } from "root/Tables/PassportTable";
import {
    customHeaderStyle,
    defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle, defaultTopRightCellStyle
} from "root/Tables/BaseTableComponents";
import format from "date-fns/format";
import {EducationStatusTypes, PepStatus, UserTypes} from "root/DataFunctions/Constants";
import SessionContext from "root/Contexts/SessionContext";
import ItemTooltip from "ui/Tooltip/ItemTooltip";
import {Link} from "react-router-dom";

export const pepRouteUrl = ( pep_id, child_id ) =>
{
    return 'pep/'+ pep_id + '?pep_id=' + pep_id + '&child_id=' + child_id ;
}

export const qaRouteUrl = ( pep_id, workitem_id ) =>
{
    return 'qa/'+ pep_id + '?pep_id=' + pep_id + '&workitem=' + workitem_id ;
}

export const childRouteUrl2 = ( child_id, params ) =>
{
    const urlBit = getParamList( params ) ;

    return 'child/'+ child_id + urlBit ;
}

export const childRouteUrl3 = ( child_id, params ) =>
{
    const urlBit = getParamList( params ) ;

    return '/vschool/child/'+ child_id + urlBit ;
}

export const childProgressReviewRoute = ( child_id, progress_review_id, params ) =>
{
    const urlBit = getParamList( params ) ;

    return 'progress/' + progress_review_id + urlBit ;
}

export const schoolRouteUrl = ( school_id, activePage, returnURL ) =>
{
    if ( activePage !== null )
    {
        return 'schools/'+ school_id + '?return=' + returnURL + '&activePage=' + activePage;
    }
    else
    {
        return school_id + '?return=' + returnURL ;
    }
}

export const userRouteUrl = ( user_id, activePage, returnURL ) =>
{
    if ( activePage !== null )
    {
        return user_id + '?return=' + returnURL + '&activePage=' + activePage;
    }
    else
    {
        return user_id + '?return=' + returnURL ;
    }
}

const TableMyPEPs = ({ data, loading, onClickDelete, onClickClose}) =>
{
    const refToolTip = useRef(null);
    const sessionContext = useContext ( SessionContext ) ;

    const paddy = (n, p, c) =>
    {
        const pad_char = typeof c !== 'undefined' ? c : '0';
        const pad = new Array(1 + p).join(pad_char);
        return (pad + n).slice(-pad.length);
    }

    const editPepHyperlink = (pep_id, child_id) =>
    {
        const url = pepRouteUrl( pep_id, child_id );

        return url;
    }


    const pepFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const url = pepRouteUrl( row.pep_id, row.child_id );

        const label = (+row?.es_type === EducationStatusTypes.NEET) ? 'Edit PEP ( NEET )' : 'Edit PEP' ;

        return <ItemTooltip text={label}><Link to={url}>{'PEP' + paddy(cell, 6, '0')}</Link></ItemTooltip>
    }

    const hyperlink_td = (label, link, tip) =>
    {
        return
    }

    const childNameFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const viewChildURL = childRouteUrl2( row.child_id, { activePage: 'setting' });
        const viewChildText = row.firstname + ' ' + row.surname;

        return <ItemTooltip text='View Pupil Details'><Link to={viewChildURL}>{viewChildText}</Link></ItemTooltip>
    }

    const editFormatter = (cell, row, rowIndex, formatExtraData) => {

        const url = editPepHyperlink(row.pep_id, row.child_id);

        const download_url = '/peppdf.php?pepId=' + row.pep_id + '&writingSpace=true&numRows=2';

        const canDelete = onClickDelete !== undefined && +(row.pep_status_id) === PepStatus.IN_PROGRESS ;

        const status = +(row.pep_status_id) ;

        const canEdit = status !== PepStatus.AWAITING_REVIEW && status !== PepStatus.AWAITING_ESW_REVIEW ;

        const shouldShowClose = +(row.pep_status_id) === PepStatus.PENDING_FURTHER_ACTION || sessionContext.user_type === UserTypes.TEAM_LEAD || sessionContext.user_type === UserTypes.ESW || sessionContext.user_type === UserTypes.PERFORMANCE_AND_DEVELOPMENT || sessionContext.user_type === UserTypes.LEAD_CAREERS_ADVISOR ;

        return (
            <Fragment key='12'>
                { shouldShowClose && <IconTooltip onClick={() => onClickClose(row.pep_id, 'close' )} placement='top' text="Close PEP" style={{marginRight: '10px'}} icon="glyphicon-folder-close" color='var(--s360-icon-orange)'/> }
                { canDelete && <IconTooltip onClick={() => onClickDelete ( 'delete', row.pep_id )} placement='top' text="DELETE this PEP" style={{marginRight: '10px'}} icon="glyphicon-trash" color="var(--s360-icon-red)"/> }
                { canEdit && <Link key='qw' to={url}><IconTooltip placement='top' text="Edit" icon="glyphicon-pencil" color="var(--s360-icon-blue)"/></Link> }
                <a key='we' href={download_url} target="_blank" style={{marginLeft: '10px'}}><IconTooltip placement='top' text="Download" icon="glyphicon-file" color="var(--s360-icon-blue)"/></a>
            </Fragment>
        );
    }

    const dateFormatter = (cell, row, enumObject, index) =>
    {
        const tst = format(cell, 'dd/MM/yyyy') ;

        return tst === '01/01/1970' ? '' : tst ;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        pep_id: {borderRadius: defaultTopLeftCellStyle, width: "100px"},
        firstname: {width: "120px"},
        year_name: {width: "50px"},
        dt_pep_date_to: {width: "50px"},
        pep_status_text: {width: "80px"},
        child_id: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "pep_id",
                text: "PEP Ref",
                sort: true,
                headerStyle: headerStyle,
                formatter: pepFormatter
            },
            {
                dataField: "firstname",
                text: "Child Name",
                sort: true,
                headerStyle: headerStyle,
                formatter: childNameFormatter
            },
            {
                dataField: "year_name",
                text: "Year",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "dt_pep_date_to",
                text: "Meeting Date",
                sort: true,
                sortType: 'datetime',
                formatter: dateFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "pep_status_text",
                text: "Status",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "child_id",
                text: "Title",
                align: 'right',
                formatter: editFormatter,
                headerStyle: headerStyle
            }
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());

    const columns = React.useMemo(() => translations, [data]);

    const tableContent = () =>
    {
        return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions}/>

    }

    return loading === true ? <SpinnerDiv/> : tableContent();
};

export default TableMyPEPs;
